/** Virtual filter id — show every public template. */
export const PUBLIC_TEMPLATE_CATEGORY_ALL = 'all';

/** Preview rows on landing before “show all samples”. */
export const LANDING_PUBLIC_TEMPLATES_PREVIEW_ROWS = 4;

/** Tailwind breakpoints used by the landing templates grid. */
const LANDING_GRID_SM_MIN_WIDTH = 640;
const LANDING_GRID_LG_MIN_WIDTH = 1024;

/** Column count for `grid-cols-1 sm:grid-cols-2 lg:grid-cols-3`. */
export const getLandingPublicTemplatesGridColumns = (width = typeof window !== 'undefined' ? window.innerWidth : LANDING_GRID_LG_MIN_WIDTH) => {
  if (width >= LANDING_GRID_LG_MIN_WIDTH) {
    return 3;
  }

  if (width >= LANDING_GRID_SM_MIN_WIDTH) {
    return 2;
  }

  return 1;
};

export const getLandingPublicTemplatesPreviewCount = (width) =>
  LANDING_PUBLIC_TEMPLATES_PREVIEW_ROWS * getLandingPublicTemplatesGridColumns(width);

/** i18n key for the “all categories” filter chip on landing. */
export const PUBLIC_TEMPLATE_CATEGORY_ALL_NAME_KEY = 'publicTemplatesCategoryAll';

/**
 * Build landing/dashboard category filters: “all” from constants, then API categories.
 * @param {{ id: string, name: string }[]} apiCategories
 * @param {(key: string) => string} translate
 */
export const buildPublicTemplateCategoryFilters = (apiCategories, translate) => [
  { id: PUBLIC_TEMPLATE_CATEGORY_ALL, name: translate(PUBLIC_TEMPLATE_CATEGORY_ALL_NAME_KEY) },
  ...apiCategories
];
